import { render, staticRenderFns } from "./_tag.vue?vue&type=template&id=19a6e0ba&scoped=true&"
import script from "./_tag.vue?vue&type=script&lang=js&"
export * from "./_tag.vue?vue&type=script&lang=js&"
import style0 from "./_tag.vue?vue&type=style&index=0&id=19a6e0ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6e0ba",
  null
  
)

export default component.exports